export interface JobAgeColor {
	stripeColor: string;
	ageLabel: string;
	businessDaysOld: number;
	isOverdue: boolean;
	showChip: boolean;
}

const COLOR_FRESH = "#4caf50";
const COLOR_DAY1 = "#fbc02d";
const COLOR_DAY23 = "#ff9800";
// Red is the end of the scale: 5+ business days, overdue included.
const COLOR_LATE = "#f44336";

export function businessDaysBetween(start: Date, end: Date): number {
	const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
	const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
	if (endDay <= startDay) return 0;
	let count = 0;
	const cursor = new Date(startDay);
	cursor.setDate(cursor.getDate() + 1);
	while (cursor <= endDay) {
		if (cursor.getDay() !== 0) count++;
		cursor.setDate(cursor.getDate() + 1);
	}
	return count;
}

export function getJobAgeColor(date: Date | string | null | undefined, now: Date = new Date()): JobAgeColor {
	// Jobs are deserialized via `Object.assign(new Job(), json)`, so date fields
	// arrive as ISO strings at runtime despite their `Date` type. Coerce defensively
	// and treat null/invalid dates as "no age".
	const parsed = date instanceof Date ? date : date ? new Date(date) : null;
	if (!parsed || Number.isNaN(parsed.getTime())) {
		return {
			stripeColor: "transparent",
			ageLabel: "",
			businessDaysOld: 0,
			isOverdue: false,
			showChip: false,
		};
	}
	const businessDaysOld = businessDaysBetween(parsed, now);
	let stripeColor: string;
	if (businessDaysOld <= 0) stripeColor = COLOR_FRESH;
	else if (businessDaysOld <= 2) stripeColor = COLOR_DAY1;
	else if (businessDaysOld <= 4) stripeColor = COLOR_DAY23;
	else stripeColor = COLOR_LATE;
	return {
		stripeColor,
		ageLabel: `${businessDaysOld}d`,
		businessDaysOld,
		isOverdue: businessDaysOld >= 7,
		showChip: businessDaysOld >= 2,
	};
}
